import { render, staticRenderFns } from "./CoulombLawViz.vue?vue&type=template&id=3bcf7070&scoped=true"
import script from "./CoulombLawViz.vue?vue&type=script&lang=js"
export * from "./CoulombLawViz.vue?vue&type=script&lang=js"
import style0 from "./CoulombLawViz.vue?vue&type=style&index=0&id=3bcf7070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf7070",
  null
  
)

export default component.exports